import { render, staticRenderFns } from "./collisionReminder.vue?vue&type=template&id=cff50c94&scoped=true"
import script from "./collisionReminder.vue?vue&type=script&lang=js"
export * from "./collisionReminder.vue?vue&type=script&lang=js"
import style0 from "./collisionReminder.vue?vue&type=style&index=0&id=cff50c94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff50c94",
  null
  
)

export default component.exports